
import { Vue, Component } from 'vue-property-decorator'
import Subelement from '@/types/subelement'
import SubelementShowDetailsTab from '@/views/subelement/tabs/show/SubelementShowDetailsTab.vue'
import SubelementShowElementsTab from '@/views/subelement/tabs/show/SubelementShowElementsTab.vue'
import SubelementShowOptionsTab from '@/views/subelement/tabs/show/SubelementShowOptionsTab.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { SubelementShowOptionsTab, SubelementShowElementsTab, SubelementShowDetailsTab }
})

export default class SubelementShow extends Vue {
  settings = {
    routeNames: { list: 'subelements', show: 'subelementShow', edit: 'subelementEdit' },
    routeParamKey: 'subelementId',
    functionNames: { setCurrent: 'setCurrentSubelement', clearCurrent: 'clearCurrentSubelement', save: 'saveSubelement' },
    getterNames: { current: 'currentSubelement', loading: 'loadingSubelement' }
  }

  currentTab:string = ls.get('subelementEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  setActiveTab (tab:string) : void {
    ls.set('subelementEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Subelement {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
